// Optional helper function (if you need notifications)
export function showNotification(notificationText: string, style: string, notificationService: any): void {
  notificationService.show({
    content: notificationText,
    hideAfter: 5000,
    position: { horizontal: 'center', vertical: 'top' },
    animation: { type: 'slide', duration: 400 },
    type: { style, icon: true },
  });
}
